"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcActionDropdownItem_1 = require("./AcActionDropdownItem");
var AcDropdownToggle_1 = require("./AcDropdownToggle");
var AcActionDropdown_module_scss_1 = __importDefault(require("./AcActionDropdown.module.scss"));
exports.AcActionDropdown = function (props) {
    var id = props.id, title = props.title, align = props.align, _a = props.actions, actions = _a === void 0 ? [] : _a, data = props.data, functionContext = props.functionContext, dropdownClassName = props.dropdownClassName, disableDropdownIcon = props.disableDropdownIcon, size = props.size, alignRight = props.alignRight, _b = props.menuMinWidth, menuMinWidth = _b === void 0 ? '14rem' : _b;
    var titleNode;
    if (typeof title === 'function') {
        titleNode = title(data || {}, functionContext || {});
    }
    else {
        titleNode = title;
    }
    return (react_1.default.createElement(react_bootstrap_1.Dropdown, { alignRight: alignRight || align === 'alignRight', drop: "down" },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { as: AcDropdownToggle_1.AcDropdownToggle, id: id, className: (dropdownClassName !== null && dropdownClassName !== void 0 ? dropdownClassName : '') + " " + (disableDropdownIcon ? AcActionDropdown_module_scss_1.default.disableDropdownToggleIcon : '') }, titleNode),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { style: { minWidth: menuMinWidth } }, actions
            .filter(function (action) {
            if (typeof action.hide === 'function') {
                return !action.hide(data || {}, functionContext || {});
            }
            return !action.hide;
        })
            .map(function (action, index) {
            return (react_1.default.createElement(AcActionDropdownItem_1.AcActionDropdownItem, { key: "" + index, eventKey: "" + index, data: data, functionContext: functionContext, action: action, size: size }));
        }))));
};
exports.AcActionDropdown.displayName = 'AcActionDropdown';
//# sourceMappingURL=AcActionDropdown.js.map